import API from '../../../../services/apiService.js'

var api= new API();


export default {

  // Загрузить список типов партнеров
  async loadPartnerTypes ({ commit }) {
    var data=null;
    try{
      data = await api.Get("DirectoryService/PartnerType");
      commit('loadPartnerTypes', data);
    }catch (e) {
      console.log(e);
      throw new Error(e);
    }
  },

}
